import { render, staticRenderFns } from "./RoleInputs.vue?vue&type=template&id=67fcd5c4&"
import script from "./RoleInputs.vue?vue&type=script&lang=ts&"
export * from "./RoleInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports